<template>
   <BetsTable/>
</template>

<script>

import BetsTable from '@/components/user/modules/betsTable';
export default {
   name: "HorseBets",
   components:{
      BetsTable
   }
}
</script>

<style scoped>

</style>
